import React, { Component } from "react";
import { DialogTitle, DialogActions } from "@material-ui/core";

import { BeautifulDialog, DialogContent } from "js/react/components/Dialogs/BaseDialog";
import { BlueButton, BlueOutlinedButton } from "js/react/components/UiComponents";
import AddressForm from "js/react/components/AddressForm";
import FetchingClickShield from "js/react/components/FetchingClickShield";

export default class UpdateBillingAddressDialog extends Component {
    constructor(props) {
        super(props);

        this.state = {
            address: { ...props.address },
            isAddressValid: !!props.address,
            fetching: false
        };
    }

    handleChangeAddress = ({ address, isValid }) => this.setState({ address, isAddressValid: isValid })

    handleUpdate = async () => {
        const { onAccept, closeDialog } = this.props;
        const { address } = this.state;

        this.setState({ fetching: true });

        // onAccept should never throw
        await onAccept(address);

        closeDialog();
    }

    render() {
        const { hideBackdrop, closeDialog, title = "Billing address", canCancel = true } = this.props;
        const { fetching, address, isAddressValid } = this.state;

        return (
            <BeautifulDialog
                hideBackdrop={hideBackdrop}
                closeDialog={() => { }}
            >
                <DialogTitle>
                    {title}
                </DialogTitle>
                <DialogContent>
                    <FetchingClickShield visible={fetching} backgroundColor="rgba(255,255,255,0.5)" />
                    <AddressForm address={address} onChange={this.handleChangeAddress} />
                </DialogContent>
                <DialogActions>
                    {canCancel && <BlueOutlinedButton disabled={fetching} onClick={closeDialog}>
                        Cancel
                    </BlueOutlinedButton>}
                    <BlueButton
                        disabled={!isAddressValid || fetching}
                        onClick={this.handleUpdate}>
                        Update
                    </BlueButton>
                </DialogActions>
            </BeautifulDialog>
        );
    }
}
